import axios from 'axios';

// Create axios instance
const invoiceApi = axios.create({
  baseURL: process.env.REACT_APP_INVOICE_API,
});

export { invoiceApi };
